var _class, _temp;

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

import * as React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Grid, Container, Form, Input, Button, Message } from 'semantic-ui-react';
import { withRouter } from 'react-router-dom';
import { loginUserandGetData, clearLoginForm } from '../actions';
import { getAuthToken } from '../helpers';
import LoginForm from '../components/LoginForm';
var LogIn = (_temp = _class = function (_React$Component) {
  _inherits(LogIn, _React$Component);

  function LogIn(props) {
    _classCallCheck(this, LogIn);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this.handleSubmit = function (formData) {
      _this.props.loginUserandGetData(formData.email, formData.password).then(function (success) {
        return success === true ? _this.props.history.push(_this.props.redirectTo) : false;
      });
    };

    _this.state = {
      authToken: getAuthToken()
    };
    return _this;
  }

  LogIn.prototype.componentDidMount = function componentDidMount() {
    this.props.clearLoginForm();
  };

  LogIn.prototype.render = function render() {
    var _props = this.props,
        isFetching = _props.isFetching,
        error = _props.error,
        loginStatus = _props.loginStatus;
    return React.createElement('div', {
      className: 'page--multifaceted-bg-grey'
    }, React.createElement(Container, {
      className: 'page-container'
    }, React.createElement('div', {
      className: 'login-form'
    }, React.createElement(Grid, {
      stackable: true,
      centered: true
    }, React.createElement(Grid.Column, {
      width: 6
    }, React.createElement('div', {
      className: 'callout'
    }, React.createElement('h2', null, 'Log In'), React.createElement(Grid, {
      stackable: true,
      centered: true
    }, React.createElement(Grid.Column, {
      width: 10
    }, error && React.createElement(Message, {
      warning: true,
      icon: false,
      content: error
    }), React.createElement(LoginForm, {
      handleSubmit: this.handleSubmit,
      isFetching: isFetching || loginStatus,
      error: error
    })))))))));
  };

  return LogIn;
}(React.Component), _class.defaultProps = {
  redirectTo: '/'
}, _temp);

var mapStateToProps = function mapStateToProps(state) {
  return {
    isFetching: state.auth.user.isFetching,
    loginStatus: state.auth.loginStatus.isFetching,
    error: state.auth.user.error
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    loginUserandGetData: loginUserandGetData,
    clearLoginForm: clearLoginForm
  }, dispatch);
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(LogIn));